import { useEffect } from 'react'

import sanitizeError from '~/utils/sanitizeError'
import { DEFAULT_DATA_ITEM } from '~/utils/slices/constants'

import type { ProductVariant } from '../@types'
import { fetchProductVariant } from '../api'
import useProductVariantsSlice from '../slices/useProductVariantsSlice'

type Options = {
  avoidRefetch?: boolean
}

const useProductVariant = (id?: ProductVariant['id'], options?: Options) => {
  const state = useProductVariantsSlice(
    state => (id ? state.items[id] : undefined) || DEFAULT_DATA_ITEM,
  )

  const { setItemLoadStart, setItemLoadSuccess, setItemLoadFailure, getItem } =
    useProductVariantsSlice.getState()

  useEffect(() => {
    if (!id) return
    const item = getItem(id)
    if (item?.loading || (item?.loaded && options?.avoidRefetch)) return

    setItemLoadStart(id, null)

    void (async () => {
      try {
        const data = await fetchProductVariant(id)
        setItemLoadSuccess(id, data)
      } catch (error) {
        setItemLoadFailure(id, sanitizeError(error))
      }
    })()
  }, [id])

  return state
}

export default useProductVariant
